module.exports = __webpack_public_path__ + "media/1.8c4bd359.mp3";